import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { useApi } from "./api";
import { offlineNow, isNetErr } from "./idb";
import { useDomTranslator } from "./domTranslate";

const T = {
  "Dashboard": ["डैशबोर्ड", "ડેશબોર્ડ", "डॅशबोर्ड", "డాష్‌బోర్డ్"],
  "Home": ["होम", "હોમ", "होम", "హోమ్"],
  "Sites": ["साइट्स", "સાઇટ્સ", "साइट्स", "సైట్లు"],
  "Workers": ["श्रमिक", "કામદારો", "कामगार", "కార్మికులు"],
  "Worker Roster": ["श्रमिक सूची", "કામદાર યાદી", "कामगार यादी", "కార్మికుల జాబితా"],
  "Attendance": ["उपस्थिति", "હાજરી", "हजेरी", "హాజరు"],
  "Payroll": ["वेतन", "પગારપત્રક", "पगार", "జీతాలు"],
  "Monthly Wages": ["मासिक वेतन", "માસિક વેતન", "मासिक वेतन", "నెలవారీ వేతనాలు"],
  "Challan Proofs": ["चालान प्रमाण", "ચલણ પુરાવા", "चलन पुरावे", "చలాన్ రుజువులు"],
  "Payment Holds": ["भुगतान रोक", "ચુકવણી રોક", "देयक रोख", "చెల్లింపు నిలుపుదల"],
  "Reports": ["रिपोर्ट", "રિપોર્ટ્સ", "अहवाल", "నివేదికలు"],
  "Documents": ["दस्तावेज़", "દસ્તાવેજો", "कागदपत्रे", "పత్రాలు"],
  "Generate Documents": ["दस्तावेज़ बनाएं", "દસ્તાવેજો બનાવો", "कागदपत्रे तयार करा", "పత్రాలు రూపొందించండి"],
  "Settings": ["सेटिंग्स", "સેટિંગ્સ", "सेटिंग्ज", "సెట్టింగ్‌లు"],
  "Alerts": ["अलर्ट", "ચેતવણીઓ", "सूचना", "హెచ్చరికలు"],
  "Principal Employers": ["प्रधान नियोक्ता", "મુખ્ય નોકરીદાતા", "मुख्य नियोक्ता", "ప్రధాన యజమానులు"],
  "Vendor Partners": ["ठेकेदार", "કોન્ટ્રાક્ટર", "ठेकेदार", "కాంట్రాక్టర్లు"],
  "Wage Register": ["वेतन रजिस्टर", "વેતન રજિસ્ટર", "वेतन नोंदवही", "వేతన రిజిస్టర్"],
  "More": ["अधिक", "વધુ", "अधिक", "మరిన్ని"],
  "Sign Out": ["साइन आउट", "સાઇન આઉટ", "साइन आउट", "సైన్ అవుట్"],
  "My Profile": ["मेरी प्रोफ़ाइल", "મારી પ્રોફાઇલ", "माझे प्रोफाइल", "నా ప్రొఫైల్"],
  "Manage Users": ["उपयोगकर्ता प्रबंधन", "વપરાશકર્તાઓ", "वापरकर्ते व्यवस्थापन", "వినియోగదారుల నిర్వహణ"],
  "Total Workers": ["कुल श्रमिक", "કુલ કામદારો", "एकूण कामगार", "మొత్తం కార్మికులు"],
  "Present Today": ["आज उपस्थित", "આજે હાજર", "आज हजर", "ఈరోజు హాజరు"],
  "Pending Docs": ["लंबित दस्तावेज़", "બાકી દસ્તાવેજો", "प्रलंबित कागदपत्रे", "పెండింగ్ పత్రాలు"],
  "Issues": ["समस्याएं", "સમસ્યાઓ", "समस्या", "సమస్యలు"],
  "Compliance by Site": ["साइट अनुसार अनुपालन", "સાઇટ મુજબ અનુપાલન", "साइटनुसार अनुपालन", "సైట్ వారీ అనుసరణ"],
  "Quick actions": ["त्वरित कार्य", "ઝડપી ક્રિયાઓ", "जलद कृती", "త్వరిత చర్యలు"],
  "Recent activity": ["हाल की गतिविधि", "તાજેતરની પ્રવૃત્તિ", "अलीकडील क्रिया", "ఇటీవలి కార్యకలాపం"],
  "Add Worker": ["श्रमिक जोड़ें", "કામદાર ઉમેરો", "कामगार जोडा", "కార్మికుడిని జోడించండి"],
  "Compliance": ["अनुपालन", "અનુપાલન", "अनुपालन", "అనుసరణ"],
  "Licenses": ["लाइसेंस", "લાઇસન્સ", "परवाने", "లైసెన్సులు"],
  "PF/ESIC Filings": ["पीएफ/ईएसआईसी फाइलिंग", "PF/ESIC ફાઇલિંગ", "पीएफ/ईएसआयसी भरणा", "PF/ESIC ఫైలింగ్‌లు"],
  "Welcome": ["स्वागत है", "સ્વાગત છે", "स्वागत आहे", "స్వాగతం"],
  "Licences Expired": ["समाप्त लाइसेंस", "સમાપ્ત લાઇસન્સ", "कालबाह्य परवाने", "గడువు ముగిసిన లైసెన్సులు"],
  "Expiring in 30 Days": ["30 दिनों में समाप्त", "30 દિવસમાં સમાપ્ત", "30 दिवसांत संपणारे", "30 రోజుల్లో ముగిసేవి"],
  "AI Assistant": ["एआई सहायक", "AI સહાયક", "एआय सहाय्यक", "AI సహాయకుడు"],
  "PE Filings": ["प्रधान नियोक्ता फाइलिंग", "મુખ્ય નોકરીદાતા ફાઇલિંગ", "मुख्य नियोक्ता भरणा", "ప్రధాన యజమాని ఫైలింగ్‌లు"],
  "Wage Raises": ["वेतन वृद्धि", "વેતન વધારો", "वेतनवाढ", "వేతన పెంపు"],
  "Site Visits": ["साइट दौरे", "સાઇટ મુલાકાતો", "साइट भेटी", "సైట్ సందర్శనలు"],
  "Laws & Rules": ["कानून और नियम", "કાયદા અને નિયમો", "कायदे व नियम", "చట్టాలు & నియమాలు"],
  "My Score": ["मेरा स्कोर", "મારો સ્કોર", "माझा स्कोअर", "నా స్కోర్"],
  "My Filings": ["मेरी फाइलिंग", "મારી ફાઇલિંગ", "माझे भरणे", "నా ఫైలింగ్‌లు"],
  "Organisation": ["संगठन", "સંસ્થા", "संस्था", "సంస్థ"],
  "Save": ["सहेजें", "સાચવો", "जतन करा", "సేవ్ చేయండి"],
  "Language": ["भाषा", "ભાષા", "भाषा", "భాష"],
  "Mark all present": ["सभी उपस्थित", "બધા હાજર", "सर्व हजर", "అందరూ హాజరు"],
  "Present": ["उपस्थित", "હાજર", "हजर", "హాజరు"],
  "Absent": ["अनुपस्थित", "ગેરહાજર", "गैरहजर", "గైర్హాజరు"],
  "Half day": ["आधा दिन", "અડધો દિવસ", "अर्धा दिवस", "అర్ధ రోజు"],
  "Leave": ["छुट्टी", "રજા", "रजा", "సెలవు"],
  "Review now": ["अभी देखें", "હમણાં જુઓ", "आता पहा", "ఇప్పుడే చూడండి"],
  "Company": ["कंपनी", "કંપની", "कंपनी", "కంపెనీ"],
  "Users": ["उपयोगकर्ता", "વપરાશકર્તાઓ", "वापरकर्ते", "వినియోగదారులు"],
  "Wage Master": ["न्यूनतम वेतन तालिका", "લઘુત્તમ વેતન કોષ્ટક", "किमान वेतन तक्ता", "కనీస వేతన పట్టిక"],
  "Name": ["नाम", "નામ", "नाव", "పేరు"],
  "Email": ["ईमेल", "ઈમેલ", "ईमेल", "ఇమెయిల్"],
};
const LANGS = [["en", "English"], ["hi", "हिन्दी"], ["gu", "ગુજરાતી"], ["mr", "मराठी"], ["te", "తెలుగు"]];
const IDX = { hi: 0, gu: 1, mr: 2, te: 3 };

const Ctx = createContext(null);

export function MemberProvider({ children }) {
  const api = useApi();
  const [me, setMe] = useState(null);
  const [lang, setLangState] = useState(localStorage.getItem("c369-lang") || "en");
  const reload = useCallback(async () => {
    const cached = () => JSON.parse(localStorage.getItem("c369-me") || "null");
    if (offlineNow()) return setMe(cached() || { error: true });
    try { const d = (await api.get("/me")).data; setMe(d); localStorage.setItem("c369-me", JSON.stringify(d)); }
    catch (e) { setMe((isNetErr(e) && cached()) || { error: true }); }
  }, [api]);
  useEffect(() => { reload(); }, [reload]);
  const setLang = (l) => { setLangState(l); localStorage.setItem("c369-lang", l); window.dispatchEvent(new Event("c369-lang")); };
  const t = useCallback((s) => (lang === "en" || !T[s] ? s : T[s][IDX[lang]]), [lang]);
  useDomTranslator(lang);
  return <Ctx.Provider value={{ me, reload, lang, setLang, t, LANGS }}>{children}</Ctx.Provider>;
}

export const useMember = () => useContext(Ctx);
